module.exports = __webpack_public_path__ + "img/circle-ellipsis-vertical.1fe6d54b.svg";